import React, { PropTypes } from "react";
import ComponentRegistry from "Fratello/Common/ComponentRegistry";
import extend from "extend";

let search = null;

export default function CollectionPointsView({
    view,
    views,
    labels,
    address,
    error,
    value,
    markers,
    options,
    children,
    onSearch,
    onSwitchView,
    onChange,
    onLocationChange,
}) {
    const View = ComponentRegistry.get(views[view]);

    return (
      <fieldset className="group-collectionpoints">
        <div className="clearfix addressbar">

          <div className="clearfix">
            <p>{labels.label}</p>
          </div>

          <div className="search clearfix">
            <div className="input-group input-group-search b-1">
              <input
                type="text"
                ref={(node) => { search = node; }}
                className="form-control"
                defaultValue={address}
                onKeyPress={(event) => {
                    if (event.charCode === 13 || event.keyCode === 13) {
                        event.preventDefault();
                        onSearch(event.target.value);
                    }
                }}
                onFocus={(event) => {
                    event.preventDefault();
                    event.target.select();
                }}
              />
                <button
                  type="button" className="btn btn-default" onClick={(event) => {
                      event.preventDefault();
                      onSearch(search.value);
                  }}
                >{labels.search}</button>
            </div>
          </div>

          <div className="clearfix mt-10">
            <div className="btn-group text-right" role="group">
              <button
                type="button" className={`btn btn-${view === "map" ? "primary" : "default"}`} onClick={(event) => {
                    event.preventDefault();
                    onSwitchView("map");
                }}
              >{labels.map}</button>
              <button
                type="button" className={`btn btn-${view === "list" ? "primary" : "default"}`} onClick={(event) => {
                    event.preventDefault();
                    onSwitchView("list");
                }}
              >{labels.list}</button>
            </div>
          </div>
        </div>
        {error ? <div className="error-msg">{error}</div> : null}

        <View
          address={address}
          options={options}
          markers={markers.map(marker => extend(marker, { active: value && value.id === marker.id }))}
          value={value}
          onLocationChange={onLocationChange}
          onChange={onChange}
        />

        {children}

      </fieldset>
    );
}

CollectionPointsView.propTypes = {
    view: PropTypes.string.isRequired,
    views: PropTypes.shape({}),
    address: PropTypes.string,
    error: PropTypes.string,
    markers: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })),
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
    options: PropTypes.shape({}),
    value: PropTypes.shape({
        id: PropTypes.string.isRequired,
    }),
    labels: PropTypes.shape({
        list: PropTypes.string,
        map: PropTypes.string,
        search: PropTypes.string,
        label: PropTypes.string,
    }).isRequired,
    onSwitchView: PropTypes.func.isRequired,
    onLocationChange: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Checkout/Views/CollectionPointsView.jsx